
import { createAction, props } from '@ngrx/store';
import { SalesUser } from '../../models/SalesUser';
import { ChangeCoinsModel } from '../../services/SalesUserService';
import { Customer } from '../../models/Customer';

// Load all sales users
export const loadSalesUsers = createAction('[SalesUser] Load Sales Users');
export const loadSalesUsersSuccess = createAction('[SalesUser] Load Sales Users Success', props<{ salesUsers: SalesUser[] }>());
export const loadSalesUsersFailure = createAction('[SalesUser] Load Sales Users Failure', props<{ error: any }>());

// Get current sales user (me)
export const loadSalesUserMe = createAction('[SalesUser] Load Sales User Me');
export const loadSalesUserMeSuccess = createAction('[SalesUser] Load Sales User Me Success', props<{ salesUser: SalesUser }>());
export const loadSalesUserMeFailure = createAction('[SalesUser] Load Sales User Me Failure', props<{ error: any }>());

// Get sales user by Azure Object ID
export const loadSalesUser = createAction('[SalesUser] Load Sales User', props<{ azureObjectId: string }>());
export const loadSalesUserSuccess = createAction('[SalesUser] Load Sales User Success', props<{ salesUser: SalesUser }>());
export const loadSalesUserFailure = createAction('[SalesUser] Load Sales User Failure', props<{ error: any }>());

// Change coins for a sales user
export const changeSalesUserCoins = createAction('[SalesUser] Change Sales User Coins', props<{ id: number, model: ChangeCoinsModel }>());
export const changeSalesUserCoinsSuccess = createAction('[SalesUser] Change Sales User Coins Success', props<{ salesUser: SalesUser }>());
export const changeSalesUserCoinsFailure = createAction('[SalesUser] Change Sales User Coins Failure', props<{ error: any }>());

// Add coins to a customer by a sales user
export const addCoinsToCustomer = createAction('[SalesUser] Add Coins To Customer', props<{ customerNo: number, model: ChangeCoinsModel }>());
export const addCoinsToCustomerSuccess = createAction('[SalesUser] Add Coins To Customer Success', props<{ customer: Customer, salesUser: SalesUser }>());
export const addCoinsToCustomerFailure = createAction('[SalesUser] Add Coins To Customer Failure', props<{ error: any }>());
